/* eslint-disable @typescript-eslint/no-unused-vars */
import GenericCard from "@ui-components/Card/GenericCard";
import GenericModal from "@ui-components/Modal/GenericModal";
import { GenericTag } from "@ui-components/Tag/GenericTag";
import React from "react";
import { PortDetailSection } from "../Port/PortDetails/PortDetailsCard";

interface StatusHistoryEntry {
  status: number;
  text: string;
  createdAt: string;
}

interface PortData {
  id: number;
  name: string;
  tag: string;
  portId: string;
  statusHistory: StatusHistoryEntry[];
}

interface RedundancySLAModalProps {
  isOpen: boolean;
  onClose: () => void;
  portDetailsData: PortDetailSection[];
  rawPortData: PortData | null;
}
//Change this data to dynamic
const dummyPortData: PortData = {
id: 1,
name: "Dummy Port",
tag: "Network",
portId: "PORT-001",
statusHistory: [
	{
	status: 2,
	text: "Finished",
	createdAt: new Date("2025-03-19T08:30:00Z").toISOString(),
	},
	{
	status: 1,
	text: "Active",
	createdAt: new Date("2025-03-20T12:45:00Z").toISOString(),
	},
	{
	status: 3,
	text: "Pending",
	createdAt: new Date("2025-03-21T15:00:00Z").toISOString(),
	},
],
};

const RedundancySLAModal: React.FC<RedundancySLAModalProps> = ({ isOpen, onClose, portDetailsData, rawPortData }) => {
	const portDetails = portDetailsData.find((section) => section.header === "Port Details");
  return (
    <GenericModal isOpen={isOpen} onClose={onClose} title="SLA & Redundancy">
      <div className="flex-wrap w-full self-start border-t py-5">
                    <div className="p-5">
						<GenericCard
							isCollapsible={false}
							bodyContent={
							<div className="flex-wrap justify-between w-full py-1">
								{portDetails && (
									<>
									<div className="flex justify-between w-full border-b pb-2">
										<h3 className="text-sm font-medium text-semantic-text-primary">SLA Status </h3>
										<p className="text-sm font-medium text-semantic-text-secondary">{String(portDetails?.items.find((item) => item.label === "Name")?.value ?? "N/A")}</p>
									</div>
									<div className="flex justify-between w-full border-b py-2">
										<h3 className="text-sm font-medium text-semantic-text-primary">Target SLA </h3>
										<p className="text-sm font-medium text-semantic-text-secondary">{String(portDetails?.items.find((item) => item.label === "Tag")?.value ?? "Port")}</p>
									</div>
									<div className="flex justify-between w-full pt-2">
										<h3 className="text-sm font-medium text-semantic-text-primary">Maintenance </h3>
										<p className="text-sm font-medium text-semantic-text-secondary">{portDetails.items.find((item) => item.label === "Location")?.value ?? "N/A"}</p>
									</div>
									</>
								)}
							</div>
							}
						/>
                        </div>
                        <div className="p-5">
                        <GenericCard
							isCollapsible={false}
							bodyContent={
							<div className="flex-wrap justify-between w-full py-1">
								{portDetails && (
									<>
									<div className="flex justify-between w-full ">
										<h3 className="text-sm font-medium text-semantic-text-primary">Reduncancy Steps </h3>
										<p className="text-sm font-medium text-semantic-text-secondary">{String(portDetails?.items.find((item) => item.label === "Name")?.value ?? "N/A")}</p>
									</div>
									</>
								)}
							</div>
							}
						/>
				</div>
				<div className="p-5">
                    <GenericCard
							isCollapsible={false}
                            headerContent="Failover history"
							bodyContent={
							<div className="flex-wrap justify-between w-full py-1">
								{portDetails && (
									<>
									<div className="flex justify-between w-full border-b pb-2">
										<h3 className="text-sm font-medium text-semantic-text-primary">Jan 14, 2025</h3>
										<p className="text-sm font-medium text-semantic-text-secondary">Failover from port A to B (3 min.)</p>
									</div>
                                    <div className="flex justify-between w-full border-b pb-2">
										<h3 className="text-sm font-medium text-semantic-text-primary">Jan 14, 2025</h3>
										<p className="text-sm font-medium text-semantic-text-secondary">Failover from port A to B (3 min.)</p>
									</div>
                                    <div className="flex justify-between w-full">
										<h3 className="text-sm font-medium text-semantic-text-primary">Jan 14, 2025</h3>
										<p className="text-sm font-medium text-semantic-text-secondary">Failover from port A to B (3 min.)</p>
									</div>
									</>
								)}
							</div>
							}
						/>
					{/* {dummyPortData?.statusHistory && dummyPortData.statusHistory.length > 0 ? (
              <StatusTable data={dummyPortData.statusHistory} />
            ) : (
              <p className="w-full text-center">No status history available</p>
            )} */}
				</div>
				<div className="flex justify-start px-5 py-5 gap-5 border-b">
                    <GenericTag label={"Last Check: 00:05 UTC"} />
				</div>
      </div>
    </GenericModal>
  );
};

export default RedundancySLAModal;